import { FILE_TYPE_ALIASES, PDF_TYPE } from '../../../../constants/file'
import { FILE_UPLOAD_DROPZONE_OPTIONS } from '../../../File'

export const INVOICE_FILE_UPLOAD_OPTIONS = {
  ...FILE_UPLOAD_DROPZONE_OPTIONS,
  accept: {
    [FILE_TYPE_ALIASES[PDF_TYPE]]: [`.${PDF_TYPE}`],
  },
  maxFiles: 1,
  multiple: false,
}
